import { useState } from 'react'
import { Button, Container, Form } from 'react-bootstrap'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { HeaderTitle } from '../../common/HeaderTitle.jsx'
import { Input } from '../../common/inputs/index.js'
import { useMojeDane } from '../../../api/domain/osoby/queries/useMojeDane.jsx'
import { useZmienDane } from '../../../api/domain/osoby/mutations/useZmienDane.jsx'

const ViewZmianaDanych = () => {
    const role = useSelector((state) => state.user.role)
    const kcId = useSelector((state) => state.user.user?.sub)
    const { data } = useMojeDane(Boolean(kcId), kcId)
    const [form, setForm] = useState({ imie: null, nazwisko: null })
    const [errors, setErrors] = useState({})
    const zmienDane = useZmienDane(setErrors)

    if (!role) {
        return <Navigate to='/' replace />
    }

    const currentImie = form.imie ?? data?.imie ?? ''
    const currentNazwisko = form.nazwisko ?? data?.nazwisko ?? ''

    const updateField = (name, value) => {
        setForm((prev) => ({ ...prev, [name]: value }))
        setErrors((prev) => ({ ...prev, [name]: undefined }))
    }

    const validateForm = () => {
        const nextErrors = {}

        if (!currentImie?.trim()) {
            nextErrors.imie = 'Pole jest wymagane.'
        }

        if (!currentNazwisko?.trim()) {
            nextErrors.nazwisko = 'Pole jest wymagane.'
        }

        setErrors(nextErrors)
        return Object.keys(nextErrors).length === 0
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        if (!validateForm()) {
            return
        }

        zmienDane.mutate({
            imie: currentImie.trim(),
            nazwisko: currentNazwisko.trim(),
        })
    }

    return (
        <>
            <HeaderTitle
                size={'h2'}
                nav={true}
                destination={'/uzytkownik/moje-dane'}
                title={'Zmiana danych'}
            />
            <Container>
                <Form className='w-100' onSubmit={handleSubmit}>
                    <div className='w-100' style={{ maxWidth: '920px' }}>
                        <Input
                            label={'Nowe imie'}
                            value={currentImie}
                            onChange={(event) =>
                                updateField('imie', event.target.value)
                            }
                            errorText={errors?.imie}
                        />
                        <Input
                            label={'Nowe nazwisko'}
                            value={currentNazwisko}
                            onChange={(event) =>
                                updateField('nazwisko', event.target.value)
                            }
                            errorText={errors?.nazwisko}
                        />
                        <Button
                            type='submit'
                            className='mt-2'
                            disabled={zmienDane.isPending}
                        >
                            Zmien imie i nazwisko
                        </Button>
                    </div>
                </Form>
            </Container>
        </>
    )
}

export default ViewZmianaDanych
